<template>
    <div>
      <div class="e-card" style="margin-top: 5px">
        <div
          class="e-card-content"
          style="display: grid; grid-template-columns: repeat(4, 1fr); column-gap: 5%"
        >
          <ejs-datepicker
            float-label-type="Always"
            v-model="actualInspectionDateStart"
            placeholder="Actual Inspection Date From "
            format="dd/MM/yyyy"
          />
          <ejs-datepicker
            float-label-type="Always"
            v-model="actualInspectionDateEnd"
            placeholder="Actual Inspection Date To "
            format="dd/MM/yyyy"
          />
          <ejs-datepicker
            float-label-type="Always"
            v-model="vocDateStart"
            placeholder="VOC Date From"
            format="dd/MM/yyyy"
          />
          <ejs-datepicker
            float-label-type="Always"
            v-model="vocDateEnd"
            placeholder="VOC Date To"
            format="dd/MM/yyyy"
          />
          <div style="width: 2%; padding-top: 4%">
            <ejs-button
              type="button"
              cssClass="e-danger"
              v-on:click.native="onOkButtonClick"
              :disabled="isButtonDisabled"
            >
              Search
            </ejs-button>
          </div>
        </div>
      </div>
      <div style="margin-top: 5px">
        <ejs-grid
          ref="grid"
          :dataSource="reports"
          :allowSorting="true"
          :allowPaging="true"
          :allowTextWrap="true"
          :pageSettings="pageSettings"
          :toolbar="toolbarOptions"
          :created="created"
          :toolbarClick="toolbarClick"
          :excelQueryCellInfo="excelQueryCellInfo"
          :allowExcelExport="true"
          height="100%"
          width="100%"
        >
          <e-columns>
            <e-column field="permitNo"
            headerText="Permit #"
            textAlign="Left"
            width="150" />
            <e-column
              field="permitStatusType"
              headerText="Permit Status"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="ownerID"
              headerText="Permit Site Owner"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="site_Name"
              headerText="Site Name"
              textAlign="Left"
              width="250"
            />
            <e-column
              field="site_Address"
              headerText="Site Address"
              textAlign="Left"
              width="250"
            />
            <e-column
              field="municipality"
              headerText="Municipality"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="regionType"
              headerText="Region"
              textAlign="Left"
              width="130"
            />
            <e-column
              field="applicantCompanyName"
              headerText="Applicant Company Name"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="applicantAddress"
              headerText="Applicant Address"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="applicantCity"
              headerText="Applicant City"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="applicantProv"
              headerText="Applicant Prov"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="applicantPostalCode"
              headerText="Applicant Postal Code"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="contractorCompanyName"
              headerText="Contractor Company Name"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="contractorAddress"
              headerText="Contractor Address"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="contractorCity"
              headerText="Contractor City"
              textAlign="Left"
              width="180"
            />
            <e-column
              field="contractorProv"
              headerText="Contractor Prov"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="contractorPostalCode"
              headerText="Contractor PostalCode"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="engineerCompanyName"
              headerText="Engineer Company Name"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="engineerAddress"
              headerText="Engineer Address"
              textAlign="Left"
              width="200"
            />
            <e-column
              field="engineerCity"
              headerText="Engineer City"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="engineerProv"
              headerText="Engineer Prov"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="engineerPostalCode"
              headerText="Engineer PostalCode"
              textAlign="Left"
              width="150"
            />
            <e-column
              field="numberOfInspectionCompleted"
              headerText="# Of Inspection Completed"
              textAlign="Left"
              width="170"
            />
            <e-column
              field="actualInspectionDate"
              headerText="Actual Inspection Date"
              textAlign="Left"
              width="150"
              type="date"
              :format="gridDateFormat"
            />
            <e-column
              field="responseDueDate"
              headerText="Response Due Date"
              textAlign="Left"
              type="date"
              :format="gridDateFormat"
              width="150"
            />
            <e-column
              field="responseCompletedDate"
              headerText="Response Completed Date"
              textAlign="Left"
              type="date"
              :format="gridDateFormat"
              width="150"
            />
            <e-column
              field="numberOfDeficiences"
              headerText="# Of Deficiences"
              textAlign="Left"
              width="170"
            />
            <e-column
              field="numberOfUnResolvedDeficiences"
              headerText="# Of UnResolved Deficiences"
              textAlign="Left"
              width="180"
            />
            <e-column
              field="vocCompletedDate"
              headerText="VOC Completed Date"
              textAlign="Left"
              type="date"
              :format="gridDateFormat"
              width="170"
            />
            <e-column
              field="inspectionDue"
              headerText="Inspection Due/OverDue"
              textAlign="Left"
              width="200"
            />
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </template>

<script>
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';

import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { applicationTypes } from '../services/usercredits-api';
import { getInspectionReports } from '../services/site-info-api';
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js'

Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);

export default {
  name: 'Inspections',
  data() {
    return {
      actualInspectionDateStart: null,
      actualInspectionDateEnd: null,
      vocDateStart: null,
      vocDateEnd: null,
      reports: null,
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 10 },
      productFields: { text: 'ProductName', value: 'ProductCode' },
      gridDateFormat : getDataGridDateFormat(),
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
    isButtonDisabled() {
      return false;
    },
  },
  async created() {
    await applicationTypes().then((x) => {
      this.applicationTypesDS = x.data.filter((sx) => sx.productType !== 'Registration').map((item) => ({
        ProductCode: item.productCode,
        ProductName: item.productName,
      }));
      this.applicationTypesDS.unshift({ ProductCode: 'All', ProductName: 'All' });
    });
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async onOkButtonClick() {
      const resp = await getInspectionReports(this.actualInspectionDateStart, this.actualInspectionDateEnd, this.vocDateStart, this.vocDateEnd);
      this.reports = resp.data;
    },
    excelQueryCellInfo(args) {
      switch(args.column.field){
        case 'actualInspectionDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'responseDueDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'responseCompletedDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'vocCompletedDate':
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Inspections.xlsx'),
          });
          break;
      }
    },
  },
};
</script>
